module.exports = __webpack_public_path__ + "media/images/favicon2023-620499f7215cb54303ace007cea3eb8a.png";